import application from 'application/application';
import jwtDecode from 'jwt-decode';

import moment from 'moment';
const controller = 'LoginController';

application.controller(controller, [
	'$scope',
	'$http',
	'$state',
	'helper',
	'API',
	'authentication',
	'ticket',
	'$rootScope',
	'$location',
	'notification',
	'$timeout',
	'$interval',
	'deviceDetector',
	'transformDate',
	'permissions',
	(
		$scope,
		$http,
		$state,
		helper,
		API,
		authentication,
		ticket,
		$rootScope,
		$location,
		notification,
		$timeout,
		$interval,
		deviceDetector,
		transformDate,
		permissions
	) => {
		const loginTicket = ticket;

		$rootScope.loadingLogin = false;

		$scope.showAppBanner = true;

		$scope.browserDetails = deviceDetector;

		$scope.toggleAppBanner = () =>
			($scope.showAppBanner = !$scope.showAppBanner);

		$timeout(() => ($rootScope.loadingLogin = false), 50);

		$scope.inputType = 'password';

		$scope.eventSeasonCampaignPeriod = () => {
			$rootScope.configCampaign = {
				active: false
			};

			// Temporizador de propaganda Black November
			let hoje = moment();

			let inicio = moment('2024-11-01').startOf('day');
			let fim = moment('2024-11-30').endOf('day');

			if (hoje.isBetween(inicio, fim, 'day', '[]')) {
				$rootScope.configCampaign.active = true;
			} else $rootScope.configCampaign.active = false;
		};

		$scope.eventSeasonCampaignPeriod();

		($scope.ticketSignIn = () => {
			if (loginTicket == null) return;

			localStorage.clear();

			$rootScope.loadingLogin = true;
			$rootScope.checkDelayedLoadingToRefresh();

			$http({
				...helper.http(API.ticketLogin, 'GET', {
					ticket: loginTicket
				})
			})
				.then(async response => {
					$scope.checkProductAdvise(response.data);

					await permissions.loadPermissions();

					localStorage.setItem('__simulatedAccess__', true);
				})
				.finally(() => ($rootScope.loadingLogin = false));
		})();

		$scope.inactivatedUser = false;
		$scope.clickCampanha = 1;
		$scope.blockedStatus = [-3, -6];
		$rootScope.blockedPlatform = '';

		$scope.showLargerBanner = false;
		$scope.showLargestBanner = false;
		$scope.bannerClass = 'overlay-campaign-image';

		$scope.validateContractStatus = async data => {
			localStorage.setItem('__authenticationToken__', data.access_token);
			localStorage.setItem('__authenticationTokenType__', data.token_type);

			await permissions.loadPermissions();

			await $http({
				...helper.http(API.clients, 'GET'),
				params: {
					...helper.httpFields(['*']),
					registrosPorPagina: -1,
					contratosAderidos: true
				}
			})
				.then(async response => {
					const mainStorage =
						JSON.parse(localStorage.getItem('_MAIN_STORAGE_')) || {};

					mainStorage.contracts = response.data.itens;

					localStorage.setItem('_MAIN_STORAGE_', JSON.stringify(mainStorage));

					const contracts = response.data.itens;

					authentication.signIn(data, {});

					const hasGroupOAB = contracts[0].contratosAderidos.some(
						element => element.permiteGrupo
					);

					const hasGroupClient = contracts[0].contratosCliente.some(
						element => element.permiteGrupo
					);

					if (hasGroupOAB || hasGroupClient) {
						localStorage.setItem('_allowedGroup_', true);
					}

					const hasOab = contracts[0].contratosCliente.some(
						element => element.convenioOAB
					);

					const activated = contracts[0].contratosCliente.some(
						register => register.idSituacaoContrato === -1
					);

					const hasActiveWithoutOab = contracts[0].contratosCliente.some(
						register => register.idSituacaoContrato === -1
					);

					const hasCortesia = !contracts[0].contratosCliente.some(
						register => register.cortesia === false
					);

					localStorage.setItem('_hasCortesiaSeasonCampaign_', hasCortesia);

					let activatedAccount = activated;

					localStorage.setItem('__authenticationUserImage__', data.foto);

					if (!hasActiveWithoutOab) {
						const clientSituation = contracts[0].contratosAderidos.some(
							plan =>
								plan.idSituacaoClienteXPlano === -1 ||
								plan.idSituacaoClienteXPlano === -11 ||
								plan.idSituacaoClienteXPlano === -12 ||
								plan.idSituacaoClienteXPlano === -13 ||
								plan.idSituacaoClienteXPlano === -14 ||
								plan.idSituacaoClienteXPlano === -15 ||
								plan.idSituacaoClienteXPlano === -16 ||
								plan.idSituacaoClienteXPlano === -17 ||
								plan.idSituacaoClienteXPlano === -18
						);

						activatedAccount = clientSituation;
					}

					if (activatedAccount) {
						localStorage.setItem('__authenticationUserBlocked__', false);

						await $scope.constractsCourtesy(contracts[0].contratosCliente);

						$scope.inactivatedUser = false;

						$rootScope.loadingLogin = false;

						window.location = '';
					} else {
						const blocked = contracts[0].contratosCliente.some(register =>
							$scope.blockedStatus.includes(register.idSituacaoContrato)
						);

						const hasInactiveWithoutOab = contracts[0].contratosCliente.some(
							register =>
								!register.convenioOAB &&
								$scope.blockedStatus.includes(register.idSituacaoContrato)
						);

						if (blocked || hasOab) {
							localStorage.setItem('__authenticationUserBlocked__', true);
							localStorage.setItem(
								'__BlockedPlatform__',
								hasOab && hasInactiveWithoutOab
									? 'BOTH'
									: hasOab
									? 'OAB'
									: 'LITE'
							);

							$rootScope.loadingLogin = false;

							location.replace('/usuario-bloqueado');
						} else {
							$scope.inactivatedUser = true;

							Object.keys(localStorage).forEach(
								value =>
									/^__authentication\w+__$/i.test(value) &&
									localStorage.removeItem(value)
							);
						}
					}
				})
				.catch(() => {
					$scope.inactivatedUser = true;
					if ($rootScope.disableMenuIcons === false) {
						$rootScope.removeAllStorageInfo();
					}
				})
				.finally(() => ($rootScope.loadingLogin = false));
		};

		$scope.checkClientContracts = async idCliente => {
			const { data } = await $http({
				...helper.http(API.customers, 'GET'),
				params: {
					...helper.httpFields(['planosVinculados.idSituacaoClienteXPlano']),
					registrosPorPagina: -1,
					IDs: idCliente,
					expansao: 'planosVinculados'
				}
			});

			return data.itens[0];
		};

		$scope.constractsCourtesy = async response => {
			localStorage.setItem('_contractsCourtesy_', JSON.stringify(response));

			let contratcsIDs = [];

			response.forEach(item => {
				contratcsIDs.push({
					idSituacaoContrato: item.idSituacaoContrato
				});

				localStorage.setItem(
					'_contratctIDsSituation_',
					JSON.stringify(contratcsIDs)
				);
			});
		};

		$scope.message = 'O email e/ou senha informados são inválidos.';
		$scope.messageBoby =
			'Verifique se o email e senha foram digitados corretamente.';

		$scope.message +=
			'<hr />' + `<div class="mt-2"><small>${$scope.messageBoby}</small></div>`;

		$scope.signIn = async auth => {
			var close = localStorage.getItem('__closePopUpCapturaAntecipada__');

			localStorage.clear();

			if (close !== null) {
				localStorage.setItem('__closePopUpCapturaAntecipada__', close);
			}

			$rootScope.loadingLogin = true;
			$rootScope.checkDelayedLoadingToRefresh();

			//Retira focus dos inputs de email e senha, para nao ser possivel multiplas requisições;
			document.getElementById('inputLoginEmail').blur();
			document.getElementById('inputLoginPassword').blur();

			//Exclui permissoes, para previnir possiveis erros, mantidos em permições antigas;
			delete sessionStorage.refreshPermissions;
			delete sessionStorage.userFeatures;

			auth['access_type'] = '94be650011cf412ca906fc335f615cdc';

			auth['grant_type'] = 'password';

			await $http({
				...helper.http(API.login, 'POST'),
				data: auth,
				messageOverride: {
					error(response, notification) {
						notification.danger($scope.message);
					}
				}
			})
				.then(async ({ data }) => {
					await $scope.checkProductAdvise(data);
				})
				.catch(({ status }) => {
					if (status === -1) notification.danger('Falha ao conectar.');

					$rootScope.loadingLogin = false;
				});
		};

		$scope.checkProductAdvise = data => {
			const user = jwtDecode(data['access_token']);

			if (['-4', '-5'].includes(user.idProdutoAdvise)) {
				$state.go('root.login');

				$rootScope.loadingLogin = false;

				const mensagem = 'Produto contratado não é compatível com o sistema';

				notification.danger(mensagem);
			} else {
				transformDate.formatDate(data.expires_in);
				$scope.validateContractStatus(data);
			}
		};

		$scope.showPassword = () =>
			($scope.inputType =
				$scope.inputType === 'password' ? 'text' : 'password');

		$rootScope.redirectSeasonCampaign = () => {
			let campanha = 'https://wa.me/5543999522101';

			campanha &&
				$('<a>')
					.attr({
						target: '_blank',
						href: campanha
					})[0]
					.click();
		};

		$scope.indexCarrosel = 0;

		// Alternar imagens na tela de login
		// setInterval(() => {
		// 	const campanhas = ['img-panel-campanha', 'img-panel'];

		// 	if ($rootScope.configCampaign.active)
		// 		campanhas.unshift($scope.bannerClass);

		// 	const rightPanel = $("[name='RightPainel']");
		// 	const textAndBtnBlog = $('.text-and-btn-blog');
		// 	const logoAdvise = $('#logo-advise')[0];

		// 	const changeCampaign = () => {
		// 		const largura = window.innerWidth;

		// 		if (largura <= 900) return;

		// 		rightPanel.removeClass().addClass(campanhas[$scope.indexCarrosel]);

		// 		if (campanhas[$scope.indexCarrosel] === 'img-panel') {
		// 			textAndBtnBlog.removeClass('d-none');
		// 			logoAdvise.style.display = 'flex';
		// 		} else {
		// 			textAndBtnBlog.addClass('d-none');
		// 			logoAdvise.style.display = 'none';
		// 		}

		// 		$scope.indexCarrosel = $scope.indexCarrosel + 1; // Incrementa o índice

		// 		if ($scope.indexCarrosel > campanhas.length - 1)
		// 			$scope.indexCarrosel = 0; // reinicia se necessário
		// 	};

		// 	changeCampaign();
		// }, 7000);

		$scope.validateBannerSize = (scopeApply = false) => {
			let previousValidation = $scope.bannerClass;

			const minRatio = 1.55;
			const maxRatio = 4.0;

			let screenRatio = window.innerWidth / window.innerHeight;

			if (screenRatio > minRatio && screenRatio <= maxRatio) {
				$scope.bannerClass = 'overlay-campaign-image-large';
			} else if (screenRatio > maxRatio) {
				$scope.bannerClass = 'overlay-campaign-image-large-contain';
			} else {
				$scope.bannerClass = 'overlay-campaign-image';
			}

			if ($scope.bannerClass != previousValidation && scopeApply) {
				$scope.$apply();
			}
		};

		$scope.validateBannerSize();

		$(window).resize(() => {
			$scope.validateBannerSize(true);
		});
	}
]);

export default controller;
